/* ============
 * Home Index Page
 * ============
 *
 * The home index page
 */

import store from '@/store';
import customerService from '@/services/customer';
import Vue from 'vue';

export default {
  components: {
    VLayout: require('@/layouts/default/default.vue'),
    VPanel: require('@/components/panel/panel.vue'),
    CreateDialog: require('@/components/customer/create-dialog.vue'),
  },
  mounted() {
    this.fetchPage();
  },
  data() {
    return {
      dialogFormVisible: false,
      selectedGroup: {},
      pageSize: 10,
      selectedPage: 1,
      selectedCustomer: {},
      deleteDialog: false,
    };
  },
  computed: {
    customers() {
      return store.state.customer.customers;
    },
    count() {
      return store.state.customer.count;
    },
  },
  methods: {
    fetchPage() {
      store.dispatch('customer/getCustomer', {
        filter: {
          limit: this.pageSize,
          skip: (this.selectedPage - 1) * this.pageSize,
          include: 'customerGroup',
        }
      });
    },
    handlePageChange(page) {
      this.selectedPage = page;
      this.fetchPage();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.fetchPage();
    },
    confirmDelete(customer) {
      this.selectedCustomer = customer;
      this.deleteDialog = true;
    },
    deleteSelectedCustomer() {
      this.deleteDialog = false;
      customerService.del(this.selectedCustomer);
      store.dispatch('customer/getCustomer', {
        filter: {
          limit: this.pageSize,
          skip: (this.selectedPage - 1) * this.pageSize,
          include: 'customerGroup',
        }
      });
    },
    navigate(data) {
      Vue.router.push(data);
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/customer/view/index.js